const _import = require('./_import_' + process.env.NODE_ENV)

export default {
  path: '/home',
  component: _import('Container'),
  name: 'home',
  redirect: '/home/dashboard',
  meta: { title: '统计', icon: 'el-icon-folder-opened', noCache: true },
  children: [{
    path: 'dashboard',
    name: 'dashboard',
    component: _import('backstage/dashboard/index'),
    meta: { title: '统计分析', icon: 'el-icon-data-analysis', noCache: true }
  }]
}



// WEBPACK FOOTER //
// ./src/router/dashboard.js